export default {
  main: {
    title: 'Version Verification',
    language: '中文',
    intro:
      'Version verification is performed by matching the MD5 or SHA256 hash values between versions. Please make sure to download TokenPocket wallet through official channels to avoid being deceived. For instructions on how to obtain the MD5 or SHA256 hash values of a version, please ',
    tutorial: 'refer to the tutorial >',
    system: 'OS',
    android: 'Android',
    ios: 'iOS',
    version: 'Version',
    allVersion: 'All',
    appChannel: 'App Channel',
    developer: 'Developer',
    allChannel: 'All',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Version Log',
    check: 'Details',
    versionLog: 'Version Log',
    confirm: 'Confirm',
    aboutIOS: 'About iOS Version',
    IOSDesc:
      'For iOS versions, we only offer our App on App Store. Only apps downloaded through the App Store can be properly installed. Therefore, when using Apple devices, please make sure to authenticate the App Store as the sole download channel.',
    IOSDesc_2:
      'The developer of the version downloaded from the App Store before October 8, 2022 is TOKENPOCKET FOUNDATION LTD, which is an early version developed by TokenPocket. It is a legitimate wallet that can be used normally, but the update service will be temporarily suspended.',
    aboutAndroid: 'About Android Version',
    androidDesc: 'The current channels for downloading TokenPocket on Android include the official website, Google Play Store, Samsung Galaxy Store, Huawei AppGallery, OPPO App Store, and Vivo App Store. Please note that some app stores may not provide the APK installation package during the download process, making it impossible to perform MD5 or SHA256 checksum verification. Therefore, when downloading, please make sure to verify the developer information carefully, as listed below!',
    IOSAppName: 'Application Name:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Application Icon:',
    AppDeveloper: 'Developer:',
    downloadLink: 'Download Url:',
    copied: 'Copied!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Follow Us',
    desc1: "TokenPocket Staffs won't send you private messages!",
    desc2:
      "Caution! You're entering TokenPocket community, there might be someone impersonating us to send you private messages! Please be aware that, anyone who sends private messages might be a scammer! We will never contact you first!",
    desc3: 'Understood, enter',
  },
  COMMON: {
    LAYOUT: {
      features: 'Features',
      products: 'Products',
      buyCryptoFooter: 'Buy Crypto',
      mobileWallet: 'Mobile Wallet',
      mobileWalletDesc: 'Crypto & DeFi mobile wallet on blockchain.',
      hardwareWallet: 'Hardware Wallet',
      hardwareWalletDesc: 'Get your KeyPal, to guard your assets.',
      extensionWallet: 'Extension Wallet',
      extensionWalletDesc: 'A better wallet on your computer.',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'Version Verification',
      versionVerificationDesc: 'Verify your wallet.',
      approvalDetector: 'Approval Detector',
      approvalDetectorDesc: 'View and unapprove your approved tokens.',
      tokenSecurity: 'Token Security',
      tokenSecurityDesc: 'Verify if the token is secure by its contract address.',
      keyGenerator: 'Key Generator',
      keyGeneratorDesc:
        'Randomly generate public and private keys for various networks.',
      tokenProfile: 'Token Profile',
      tokenProfileDesc: 'Learn all information about the token.',
      tokenClaim: 'Token Claim',
      tokenClaimDesc: 'Claim your airdrop.',
      easyInscription: 'Easy Inscription',
      easyInscriptionDesc: 'A secure inscription tool.',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'A batch sending tool for NostrAssets.',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'Send tokens to multiple recipients at once.',
  
      trade: 'Trade',
      swap: 'Transit Swap',
      swapDesc: 'Trade with the best prices.',
      bridge: 'Bridge',
      bridgeDesc: 'Seamlessly cross assets from one chain to another.',
      buyCrypto: 'Buy',
      buyCryptoDesc: 'Buy cryptocurrency with your credit cards.',
      market: 'Market',
      marketDesc: 'Real-time insights to discover hot tokens.',
  
      information: 'Information',
      blockchainGuide: 'Blockchain Guide',
      tronWallet: 'TRON Guide',
      iostWallet: 'IOST Guide',
      tpMan: 'TP Man',
  
      developers: 'Developers',
      github: 'Github (TP-Lab)',
      devCenter: 'Dev Center',
      developersDesc: 'TokenPocket developer documentation.',
      subToken: 'Submit Token',
      subTokenDesc: 'Submit your token.',
      subDApp: 'Submit DApp',
      subDAppDesc: 'Submit your DApp, and show it after audit.',
      subNFT: 'Submit NFT',
      subNFTDesc: 'Submit your NFT & arts.',
      subChain: 'Submit Chain',
      subChainDesc: 'Submit your blockchain.',
      bugBounty: 'Bug Bounty',
  
      tools: 'Tools',
  
      build: 'Build',
  
      learn: 'Learn',
  
      explorer: 'Explorer',
  
      company: 'Company',
      about: 'About',
      careers: 'Careers',
      pressKit: 'Brand Kit',
      swagShop: 'Swag Shop',
  
      support: 'Support',
      helpCenter: 'Help Center',
      helpCenterDesc: 'Your go-to resources for answers and assistance.',
      contactUs: 'Contact Us',
      contactUsDesc: 'Share your suggestions and ask any questions.',
      forum: 'Forum',
      forumDesc: 'Enjoy your talks with the community members.',
  
      legal: 'Legal',
      privacyPolicy: 'Privacy Policy',
      terms: 'Terms of Use',

      toHome: 'Home',
      defiWallet: 'DeFi Wallet',
      ETHWallet: 'Ethereum Wallet',
      ethWallet: 'ETH Wallet',

      dappStore: 'DApp Store'
    }
  }
};
